import React, { useState } from "react";

import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { Collapse, List, ListItem, ListItemText } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

import { ReactComponent as Doctors } from "../../../Assets/Images/SideNavigation/Doctors.svg";
import { ReactComponent as DoctorAssistant } from "../../../Assets/Images/SideNavigation/DoctorAssistant.svg";
import { ReactComponent as Banner } from "../../../Assets/Images/SideNavigation/Banner.svg";
import { ReactComponent as Finance } from "../../../Assets/Images/SideNavigation/Finance.svg";
import { ReactComponent as OverView } from "../../../Assets/Images/SideNavigation/Overview.svg";
import { ReactComponent as Users } from "../../../Assets/Images/SideNavigation/Users.svg";
import { ReactComponent as UserAvatarSample } from "../../../Assets/Images/UserAvatarSample.svg"; 
import { ReactComponent as Report } from "../../../Assets/Images/SideNavigation/ReportIcon.svg"; 
import {ReactComponent as Location} from "../../../Assets/Images/Location2.svg";
import {ReactComponent as Location1} from "../../../Assets/Images/Location3.svg";
import {ReactComponent as Specialty} from "../../../Assets/Images/Specialty.svg";
import {ReactComponent as Specialty2} from "../../../Assets/Images/Specialty2.svg";
import { permissionValidator, useAuth } from "../../../Store/AuthContext";
import { Theme } from "../../../Style/Theme";
import { Permission } from "../../../Utils/Constant/Permission";
import { Drawer } from "../../atoms/Drawer/Drawer";
import { SubHeader } from "../../atoms/Typography/SubHeader/SubHeader";
import { FormItemsWrap } from "../Wrap/Wrap";
import { MenuItem } from "./MenuItem";
import {
  NavBarItemClickStyle,
  NavBarSubItemstyle,
} from "./SideNavigation.style";

export const SideNavigation = ({
  open,
  toggleDrawer,
  drawerWidth,
  topNavigationBarHeight,
}) => {
  const [openMore, setOpenMore] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  const { state } = useAuth();
  const { t } = useTranslation(["common"]);

  const handleClick = () => {
    setOpenMore(!openMore);
  };

  const navigateHandler = (link) => {
    navigate(`${link}`, { replace: true });
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        zIndex: 1,
        backgroundColor: "#FFF",
        marginTop: topNavigationBarHeight,
        borderRight: "1px solid rgba(0, 0, 0, 0.12)",
        height: `calc(100vh - ${topNavigationBarHeight}px)`,
        width: `calc(${drawerWidth}px + 20px)`,
        overflowX: 'hidden',
        boxSizing: "content-box",
      }}
    >
      <Drawer
        variant="permanent"
        toggleDrawer={toggleDrawer}
        drawerWidth={drawerWidth}
        open={open}
        sx={{
        width: drawerWidth,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: drawerWidth,
          boxSizing: 'border-box',
          height: `calc(100vh - ${topNavigationBarHeight}px)`,
          overflowY: 'auto',
          scrollbarGutter: 'stable',
          backgroundColor: '#FFF',
        },
      }}
      >
      <div
       style={{
        height: `100%`,
        overflowY: "auto",
        overflowX: "hidden",
        scrollbarGutter: "stable",
        width: "100%",
      }}
      >
        <List
          style={{
            marginTop: "20px",
            paddingRight: 28,
            display: "flex",
            flexDirection: "column",
            gap: "25px",
            width: "100%",
            boxSizing: "border-box",  
          }}
          sx={{
            mt: '20px',
            pr: '28px',
            display: 'flex',
            flexDirection: 'column',
            gap: '25px',
            width: '100%',
            boxSizing: 'border-box',
             }}
        >
          <MenuItem
            visibility={
              permissionValidator(state.permissions, Permission.overview)
                ? ""
                : "none !important"
            }
            icon={
              <OverView
                role="img"
                type="img"
                aria-label="OverView Icon"
                width={"16px"}
                height={"16px"}
                fill={
                  location.pathname === "/overview"
                    ? Theme.palette.blue.dark3
                    : Theme.palette.text.grayDark
                }
              />
            }
            onMouseDown={(event) => {
              if (event.button === 1) {
                window.open("/overview", "_blank");
              } else {
                navigateHandler("/overview");
              }
            }}
            navigate={() => {
              navigateHandler("/overview");
            }}
            displayText={t("side-nav.overview")}
            isActive={location.pathname === "/overview"}
          />

          <FormItemsWrap
            direction={"row"}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <MenuItem
              icon={
                <Finance
                  role="img"
                  type="img"
                  aria-label="Finance Icon"
                  width={"16px"}
                  height={"16px"}
                  fill={
                    location.pathname === "/finance/dashboard" ||
                    location.pathname === "/finance/transactions" ||
                    location.pathname === "/finance/payments"
                      ? Theme.palette.blue.dark3
                      : Theme.palette.text.grayDark
                  }
                />
              }
              displayText={t("side-nav.finaces")}
              navigate={handleClick}
              isActive={
                location.pathname === "/finance/dashboard" ||
                location.pathname === "/finance/transactions" ||
                location.pathname === "/finance/payments"
              }
            />

            {openMore ? (
              <ExpandLess
                onClick={handleClick}
                style={{
                  ...NavBarItemClickStyle,
                  color:
                    location.pathname === "/finance/dashboard" ||
                    location.pathname === "/finance/transactions" ||
                    location.pathname === "/finance/payments"
                      ? Theme.palette.blue.dark3
                      : Theme.palette.text.grayDark,
                }}
              />
            ) : (
              <ExpandMore
                onClick={handleClick}
                style={{
                  ...NavBarItemClickStyle,
                  color:
                    location.pathname === "/finance/dashboard" ||
                    location.pathname === "/finance/transactions" ||
                    location.pathname === "/finance/payments"
                      ? Theme.palette.blue.dark3
                      : Theme.palette.text.grayDark,
                }}
              />
            )}
          </FormItemsWrap>

          <Collapse
            in={openMore}
            timeout="auto"
            unmountOnExit
            style={{
              marginTop: "-25px",
            }}
          >
            <ListItem
              sx={{
                display: permissionValidator(
                  state.permissions,
                  Permission.dashboard,
                )
                  ? ""
                  : "none !important",
              }}
              style={NavBarSubItemstyle}
              onMouseDown={(event) => {
                if (event.button === 1) {
                  window.open("/finance/dashboard", "_blank");
                } else {
                  navigateHandler("/finance/dashboard");
                }
              }}
              onClick={() => {
                navigateHandler("/finance/dashboard");
              }}
            >
              <ListItemText style={NavBarItemClickStyle}>
                <FormItemsWrap
                  marginLeft={"14px"}
                  direction={"row"}
                  gap={"10px"}
                >
                  <SubHeader
                    color={
                      location.pathname === "/finance/dashboard"
                        ? "blue.dark3"
                        : "text.grayDark"
                    }
                    text={" "}
                  />
                  <SubHeader
                    color={
                      location.pathname === "/finance/dashboard"
                        ? "blue.dark3"
                        : "text.grayDark"
                    }
                    text={t("side-nav.dashboard")}
                  />
                </FormItemsWrap>
              </ListItemText>
            </ListItem>
            <ListItem
              key={3}
              sx={{
                display: permissionValidator(
                  state.permissions,
                  Permission.transaction,
                )
                  ? ""
                  : "none !important",
              }}
              style={NavBarSubItemstyle}
              onMouseDown={(event) => {
                if (event.button === 1) {
                  window.open("/finance/transactions", "_blank");
                } else {
                  navigateHandler("/finance/transactions");
                }
              }}
              onClick={() => {
                navigateHandler("/finance/transactions");
              }}
            >
              <ListItemText style={NavBarItemClickStyle}>
                <FormItemsWrap
                  marginLeft={"14px"}
                  direction={"row"}
                  gap={"10px"}
                >
                  <SubHeader
                    color={
                      location.pathname === "/finance/transactions"
                        ? "blue.dark3"
                        : "text.grayDark"
                    }
                    text={" "}
                  />
                  <SubHeader
                    color={
                      location.pathname === "/finance/transactions"
                        ? "blue.dark3"
                        : "text.grayDark"
                    }
                    text={t("side-nav.transactions")}
                  />
                </FormItemsWrap>
              </ListItemText>
            </ListItem>
            
          </Collapse>

          <MenuItem
            visibility={
              permissionValidator(state.permissions, Permission.doctors)
                ? ""
                : "none !important"
            }
            icon={
              <Doctors
                role="img"
                type="img"
                aria-label="Doctors Icon"
                width={"16px"}
                height={"16px"}
                fill={
                  location.pathname === "/doctors"
                    ? Theme.palette.blue.dark3
                    : Theme.palette.text.grayDark
                }
              />
            }
            onMouseDown={(event) => {
              if (event.button === 1) {
                window.open("/doctors", "_blank");
              } else {
                navigateHandler("/doctors");
              }
            }}
            navigate={() => {
              navigateHandler("/doctors");
            }}
            displayText={t("side-nav.doctors")}
            isActive={location.pathname === "/doctors"}
          />

          {/*Doctor Assistant */}
          <MenuItem
            visibility={
              permissionValidator(state.permissions, Permission.doctors)
                ? ""
                : "none !important"
            }
            icon={
              <DoctorAssistant
                role="img"
                type="img"
                aria-label="Doctors Assistant Icon"
                width={"16px"}
                height={"16px"}
                fill={
                  location.pathname === "/doctorsassistants"
                    ? Theme.palette.blue.dark3
                    : Theme.palette.blue.dark3
                }
              />
            }
            onMouseDown={(event) => {
              if (event.button === 1) {
                window.open("/doctorsassistants", "_blank");
              } else {
                navigateHandler("/doctorsassistants");
              }
            }}
            navigate={() => {
              navigateHandler("/doctorsassistants");
            }}
            displayText={t("side-nav.doctor-assistants")}
            isActive={location.pathname === "/doctorsassistants"}
          />

          {/* User story TM-173 */}
          <MenuItem
            visibility={
              permissionValidator(state.permissions, Permission.users)
                ? ""
                : "none !important"
            }
            icon={
              <Users
                role="img"
                type="img"
                aria-label="Users Icon"
                width={"16px"}
                height={"16px"}
                fill={
                  location.pathname === "/users"
                    ? Theme.palette.blue.dark3
                    : Theme.palette.text.grayDark
                }
              />
            }
            onMouseDown={(event) => {
              if (event.button === 1) {
                window.open("/users", "_blank");
              } else {
                navigateHandler("/users");
              }
            }}
            navigate={() => {
              navigateHandler("/users");
            }}
            displayText={t("side-nav.users")}
            isActive={location.pathname === "/users"}
          />
          {/* Patient */}
          <MenuItem
            visibility={
              permissionValidator(state.permissions, Permission.patients)
                ? ""
                : "none !important"
            }
            icon={
              <Users
                role="img"
                type="img"
                aria-label="Patient Icon"
                width={"16px"}
                height={"16px"}
                fill={
                  location.pathname === "/patients"
                    ? Theme.palette.blue.dark3
                    : Theme.palette.text.grayDark
                }
              />
            }
            onMouseDown={(event) => {
              if (event.button === 1) {
                window.open("/patients", "_blank");
              } else {
                navigateHandler("/patients");
              }
            }}
            navigate={() => {
              navigateHandler("/patients");
            }}
            displayText={t("side-nav.patient")}
            isActive={location.pathname === "/patients"}
          />

          {/* Locations */}
          {/* Reports */}
          <MenuItem
            visibility={
              permissionValidator(state.permissions, Permission.locations)
                ? ""
                : "none !important"
            }
            icon={
              location.pathname === "/locations" ? (
                <Location
                  role="img"
                  aria-label="Location Active Icon"
                  width={16}
                  height={16}
                />
              ) : (
                <Location1
                  role="img"
                  aria-label="Location Inactive Icon"
                  width={16}
                  height={16}
                />
              )
            }
            onMouseDown={(event) => {
              if (event.button === 1) {
                window.open("/locations", "_blank");
              } else {
                navigateHandler("/locations");
              }
            }}
            navigate={() => {
              navigateHandler("/locations");
            }}
            displayText={"Locations"}
            isActive={location.pathname === "/locations"}
          />

            {/* Specialties */}
           {<MenuItem
            visibility={
              permissionValidator(state.permissions, Permission.locations)
                ? ""
                : "none !important"
            }
            icon={
              location.pathname === "/specialties" ? (
                <Specialty
                  role="img"
                  aria-label="Specialty Active Icon"
                  width={16}
                  height={16}
                />
              ) : (
                <Specialty2
                  role="img"
                  aria-label="Location Inactive Icon"
                  width={16}
                  height={16}
                />
              )
            }
            onMouseDown={(event) => {
              if (event.button === 1) {
                window.open("/specialties", "_blank");
              } else {
                navigateHandler("/specialties");
              }
            }}
            navigate={() => {
              navigateHandler("/specialties");
            }}
            displayText={"Specialties"}
            isActive={location.pathname === "/specialties"}
          />}


          {/* Reports */}
          <MenuItem
            visibility={
              permissionValidator(state.permissions, Permission.reports)
                ? ""
                : "none !important"
            }
            icon={
              <Report
                role="img"
                type="img"
                aria-label="Report Icon"
                width={"16px"}
                height={"16px"}
                fill={
                  location.pathname === "/reports"
                    ? Theme.palette.blue.dark3
                    : Theme.palette.text.grayDark
                }
               
              />
            }
            onMouseDown={(event) => {
              if (event.button === 1) {
                window.open("/reports", "_blank");
              } else {
                navigateHandler("/reports");
              }
            }}
            navigate={() => {
              navigateHandler("/reports");
            }}
            displayText={"Reports"}
            isActive={location.pathname === "/reports"}
          />

          {/* Banners */}
           <MenuItem
            visibility={
              permissionValidator(state.permissions, Permission.doctors)
                ? ""
                : "none !important"
            }
            icon={
              <Banner
                role="img"
                type="img"
                aria-label="Banners Icon"
                width={"16px"}
                height={"16px"}
                fill={
                  location.pathname === "/banners"
                    ? Theme.palette.blue.dark3
                    : Theme.palette.blue.dark3
                }
              />
            }
            onMouseDown={(event) => {
              if (event.button === 1) {
                window.open("/banners", "_blank");
              } else {
                navigateHandler("/banners");
              }
            }}
            navigate={() => {
              navigateHandler("/banners");
            }}
            displayText={"Banners"}
            isActive={location.pathname === "/banners"}
          />
         

          <MenuItem
            icon={
              <UserAvatarSample
                role="img"
                type="img"
                aria-label="UserAvatarSample Icon"
                width={"16px"}
                height={"16px"}
              />
            }
            onMouseDown={(event) => {
              if (event.button === 1) {
                window.open("/Settings", "_blank");
              } else {
                navigateHandler("/Settings");
              }
            }}
            navigate={() => {
              navigateHandler("/Settings");
            }}
            // set user's name here
            displayText={
              state?.fullName?.toString()?.trim()
                ? state?.fullName?.toString()?.trim()
                : state?.displayName?.toString()?.trim()
                ? state?.displayName?.toString()?.trim()
                : "Username"
            }
            isActive={location.pathname === "/Settings"}
          />
        </List>

        </div>

      </Drawer>
    </div>
  );
};
